<template>
  <section>
    <CommonBanner :content="content" />
    <SideProducts :sides="sides" class="products-wrap" />
  </section>
</template>

<script>
import CommonBanner from '../../components/sideBanner/index.vue';
import SideProducts from '../../components/sideProducts/index.vue';
import { useAppStore, useMenuStore } from '@/store';
import { ref, watchEffect } from 'vue';
import { useRoute } from '@/utils';

export default {
  components: {
    CommonBanner,
    SideProducts,
  },
  setup() {
    const { meta } = useRoute();
    const side = meta.parentName.split('/')[1];
    const sides = ref([]);
    const content = ref({});
    const appStore = useAppStore();
    const menuStore = useMenuStore();
    watchEffect(() => {
      sides.value = menuStore.getCurrentAsyncSideList;
      content.value = appStore.sideInfo?.find?.((e) => {
        // 分割出b-side/c-side/d-side
        return e.key == side;
      });
      // loading.value = true;
    });
    return {
      sides,
      content,
    };
  },
};
</script>

<style lang="scss" scoped>
.products-wrap {
  padding-bottom: 80px;
}
</style>
